'use client';

import { AccountPhone as Section } from '../../components/UserProfile/AccountSections';
import { createSection } from '../createSection';

export const UserProfilePhoneSection = createSection('UserProfilePhoneSection', Section);
